module.exports = __webpack_public_path__ + "img/solds.e32b40ce.svg";